var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessdenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 350,
    viewBox: "0 0 480 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 174.545,
    r: 174.545,
    fill: "#DCD6FF",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7272,
    cy: 43.6364,
    r: 17.4545,
    fill: "#F4EBFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 274.909,
    r: 13.0909,
    fill: "#F4EBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5455,
    cy: 301.091,
    r: 21.8182,
    fill: "#F4EBFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.182,
    cy: 100.364,
    r: 21.8182,
    fill: "#F4EBFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.727,
    cy: 24,
    r: 15.2727,
    fill: "#F4EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1_12544)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.605 34.9091C211.09 34.9091 178.789 52.953 159.132 80.6109C152.713 79.0971 146.019 78.2961 139.138 78.2961C91.2136 78.2961 52.3635 117.146 52.3635 165.07C52.3635 212.994 91.2136 251.844 139.138 251.844L139.138 251.844H356.073C398.006 251.844 432 217.85 432 175.917C432 133.983 398.006 99.9896 356.072 99.9896C353.094 99.9896 350.155 100.161 347.266 100.495C330.645 61.9165 292.279 34.9091 247.605 34.9091Z",
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.137,
    cy: 165.07,
    r: 86.774,
    fill: "url(#paint0_linear_1_12544)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.605,
    cy: 143.377,
    r: 108.468,
    fill: "url(#paint1_linear_1_12544)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.072,
    cy: 175.917,
    r: 75.9273,
    fill: "url(#paint2_linear_1_12544)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1_12544)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.909,
    y: 183.273,
    width: 122.182,
    height: 122.182,
    rx: 61.0909,
    fill: "#F51919",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.499 235.625V246.125M239.499 256.625H239.526M235.865 222.216L214.274 259.508C213.077 261.577 212.478 262.611 212.566 263.46C212.644 264.2 213.032 264.873 213.634 265.311C214.324 265.812 215.519 265.812 217.909 265.812H261.09C263.48 265.812 264.675 265.812 265.365 265.311C265.967 264.873 266.355 264.2 266.432 263.46C266.521 262.611 265.922 261.577 264.724 259.508L243.134 222.216C241.941 220.155 241.344 219.124 240.566 218.778C239.887 218.476 239.112 218.476 238.433 218.778C237.654 219.124 237.058 220.155 235.865 222.216Z",
    stroke: "#F51919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1_12544",
    x: 8.72691,
    y: 34.9091,
    width: 466.909,
    height: 304.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_12544"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.4545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12544"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1_12544"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43.6364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.1818
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_12544",
    result: "effect2_dropShadow_1_12544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_12544",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_12544",
    x: 161.455,
    y: 165.818,
    width: 157.091,
    height: 157.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_12544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_12544",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_12544",
    x1: 72.5072,
    y1: 107.737,
    x2: 225.911,
    y2: 251.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_12544",
    x1: 164.317,
    y1: 71.7106,
    x2: 356.073,
    y2: 251.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_12544",
    x1: 297.771,
    y1: 125.751,
    x2: 432,
    y2: 251.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessdenied);
export default __webpack_public_path__ + "static/media/accessdenied.fe1f58ca37a9fb4aca44882a34c02490.svg";
export { ForwardRef as ReactComponent };